var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2262,
    cy: 20.2263,
    r: 20,
    transform: "rotate(-179.348 20.2262 20.2263)",
    fill: "white",
    fillOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCircle);
export default __webpack_public_path__ + "static/media/social-circle.3a10b5577efabbaeda51be37e1c4e552.svg";
export { ForwardRef as ReactComponent };